import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba 3 años con el mismo vientre hinchado sin importar lo que comiera. En 5 días siguiendo las cenas del protocolo, la presión desapareció. Me desperté el sexto día y noté la diferencia antes incluso de mirarme en el espejo. Mi sueño mejoró completamente.',
    name: 'María G.',
    details: '41 años, Córdoba',
    image: 'https://randomuser.me/api/portraits/women/45.jpg'
  }, {
    quote: 'Soy nutricionista y reconozco cuando algo está basado en ciencia real. Este protocolo aplica principios de cronobiología que yo misma enseño en consulta. Lo recomendaré a mis pacientes.',
    name: 'Dra. Patricia M.',
    details: '38 años, Rosario',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ea8cd388-6098-4d03-9bcc-d2c3a0ebfcd7.jpg'
  }, {
    quote: 'Probé todo. Jugos detox, ayuno intermitente, dietas sin gluten. Nada funcionaba a largo plazo. Con este método no paso hambre, como comida deliciosa y llevo 3 semanas sin hinchazón. Mi marido nota la diferencia también.',
    name: 'Carmen R.',
    details: '47 años, Mendoza',
    image: 'https://randomuser.me/api/portraits/women/52.jpg'
  }, {
    quote: 'Lo que más me sorprendió fue la energía. No esperaba que cambiar la cena mejorara tanto mi nivel de energía por las mañanas. Llevo 2 semanas sin necesitar cafeína hasta las 10 AM.',
    name: 'Lucía V.',
    details: '39 años, La Plata',
    image: 'https://randomuser.me/api/portraits/women/37.jpg'
  }, {
    quote: 'Pensé que era el precio normal de tener más de 40. Que el cuerpo simplemente cambia y ya. Este protocolo me demostró que no. Mi cuerpo puede responder, solo necesitaba la información correcta.',
    name: 'Ana B.',
    details: '44 años, Mar del Plata',
    image: 'https://randomuser.me/api/portraits/women/59.jpg'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream relative" data-id="element-523" data-mp="3e8xc58b5r3k">
      <div className="max-w-5xl mx-auto" data-id="element-524" data-mp="8d2fiayji6a2">
        <div className="text-center mb-16" data-id="element-525" data-mp="8c0sr985vvci">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-526" data-mp="dcf16sdod7b2">
            Lo Que Ocurre Cuando Sigues El Protocolo
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-527" data-mp="ib9refdz1y57"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-528" data-mp="3gv8agszf79zf">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-white p-8 rounded-2xl shadow-warm border border-forest/5 relative flex flex-col ${index === testimonials.length - 1 ? 'md:col-span-2 lg:col-span-1 md:w-1/2 lg:w-full md:mx-auto' : ''}`} data-id="element-529" data-mp="3qruujfjx9x0e" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-gold/20" size={48} data-id="element-530" data-mp="2y2xdtgvd089r" />

              <div className="flex gap-1 mb-6" data-id="element-531" data-mp="1k75qqtxpolv0">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-gold text-gold" data-id="element-532" data-mp="1g5kixn01axro" data-mpi={i} />)}
              </div>

              <p className="text-dark/80 italic text-lg mb-8 flex-grow relative z-10" data-id="element-533" data-mp="1b67mqbn9wecf">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-forest/10" data-id="element-534" data-mp="166uz3ookv38s">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-gold/30" data-id="element-535" data-mp="11936esg3zd3j" />
                <div data-id="element-536" data-mp="sg81jzujzjea">
                  <p className="font-bold text-forest" data-id="element-537" data-mp="sdlrntk6wrsw">{testimonial.name}</p>
                  <p className="text-sm text-dark/60" data-id="element-538" data-mp="niq00uiv86gb">{testimonial.details}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}